import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet, ActivatedRoute } from '@angular/router';
import { WebAnalyticsFiltersComponent } from '../../components/web-analytics-filters/web-analytics-filters.component';
import { defaultFilterQueryParams } from '../../utils/web-analytics-route-sync';

@Component({
  selector: 'app-web-analytics-shell',
  imports: [WebAnalyticsFiltersComponent, RouterOutlet],
  templateUrl: './web-analytics-shell.component.html',
  styleUrl: './web-analytics-shell.component.scss',
})
export class WebAnalyticsShellComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    const q = this.route.snapshot.queryParamMap;
    if (!q.get('startDate') || !q.get('endDate')) {
      void this.router.navigate([], {
        relativeTo: this.route,
        queryParams: defaultFilterQueryParams(7),
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }
  }
}
